<aside class="sidebar">

  <!-- Logo -->
  <div class="logo-block">
    <img src="icons/gpion-lockup.svg" class="logo-lockup" alt="gpion" />
    <span class="beta-pill">BETA</span>
  </div>

  <!-- Nav items -->
  <nav class="nav-items">

    <div class="nav-item nav-item--dim">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 12l2-2 7 7 7-7 2 2"/>
      </svg>
      Overview
    </div>

    <a class="nav-item" routerLink="/devices" routerLinkActive="nav-item--active">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/>
      </svg>
      Devices
    </a>

    <div class="nav-item nav-item--dim">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M23 7l-7 5 7 5V7zM1 5h15v14H1z"/>
      </svg>
      Streams
    </div>

    <div class="nav-item nav-item--dim">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
      Tasks
      <span class="nav-count">3</span>
    </div>

    <div class="nav-item nav-item--dim">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      </svg>
      Builds
    </div>

    <div class="nav-item nav-item--dim">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 6v6l4 2"/>
        <circle cx="12" cy="12" r="10"/>
      </svg>
      History
    </div>

  </nav>

  <!-- Footer -->
  <div class="sidebar-footer">
    <div class="footer-info">
      <div class="footer-org">gpion workspace</div>
      <div class="footer-ver">v0.1.0</div>
    </div>
    <button class="logout-btn" title="Logout" (click)="handleLogout()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
      </svg>
    </button>
  </div>

</aside>
